import './assets/main.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'


if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(search: any, replace: any) {
        return this.replace(new RegExp(search, 'g'), replace);
    };
}

const app = createApp(App)

app.use(router)
app.use(autoAnimatePlugin)
app.use(createPinia())

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(ElementPlus)
app.mount('#app')